const HTTP_STATUS_SUFFIX_RE = /\s*\(HTTP\s+\d{3}\)\s*$/i;

export function sanitizeUserFacingErrorMessage(
  message: string | undefined | null,
  fallback = "An error occurred. Please try again.",
): string {
  const clean = (message ?? "").trim().replace(HTTP_STATUS_SUFFIX_RE, "").trim();
  return clean || fallback;
}

export function sanitizeOptionalUserFacingErrorMessage(
  message: string | undefined | null,
): string | undefined {
  const clean = sanitizeUserFacingErrorMessage(message, "");
  return clean || undefined;
}

export function describeApiErrorForUser(
  error: unknown,
  fallback = "An error occurred. Please try again.",
): string {
  if (error && typeof error === "object") {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string") {
      return sanitizeUserFacingErrorMessage(message, fallback);
    }
  }
  if (error instanceof Error) {
    return sanitizeUserFacingErrorMessage(error.message, fallback);
  }
  return fallback;
}
